import { iconUrl } from "../../shared/icons.js";
import type { Stack } from "../../shared/stack.js";
import { h } from "../dom.js";

// Pictures that failed to load this session, so lists don't flash a broken image on every render.
const missing = new Set<string>();

/**
 * The stack's picture from the icons folder, or its coloured type dot when it has none.
 * `size` is in CSS pixels; NEI icons are pixel art, so they are scaled without smoothing.
 */
export function stackIcon(stack: Stack, size: "sm" | "lg" = "sm"): HTMLElement {
  const url = iconUrl(stack);
  const dot = h("span", { class: `type-dot ${stack.type}`, title: stack.type });
  if (missing.has(url)) return dot;
  return h("img", {
    class: `stack-icon ${size}`,
    src: url,
    alt: "",
    loading: "lazy",
    decoding: "async",
    // A patch may keep an older <img> and give it this handler, so it works on the event's element.
    onerror: (e: Event) => {
      missing.add(url);
      (e.currentTarget as Element).replaceWith(dot);
    },
  });
}
